export default function dig(object, ...path) {
  if (!object) return null;
  for (let key of path) {
    object = object[key];
    if (object === undefined || object === null) return null;
  }
  return object;
}
